"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AssetMetadataEditor = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Repeater = _interopRequireDefault(require("@civicplus/preamble/lib/Repeater/Repeater"));

var _Grid = _interopRequireDefault(require("@civicplus/preamble/lib/Grid"));

var _TextInput = _interopRequireDefault(require("@civicplus/preamble/lib/TextInput"));

var _useDebounce = require("use-debounce");

var _FormLabel = _interopRequireDefault(require("@civicplus/preamble/lib/FormLabel/FormLabel"));

var AssetMetadataEditor = function AssetMetadataEditor(props) {
  var _useDebouncedCallback = (0, _useDebounce.useDebouncedCallback)(function () {
    var result = {};
    values.forEach(function (v) {
      result[v[0]] = v[1];
    });
    props.onChange(result);
  }, 500),
      _useDebouncedCallback2 = (0, _slicedToArray2["default"])(_useDebouncedCallback, 1),
      onChange = _useDebouncedCallback2[0];

  var initialValues = function initialValues() {
    var metadata = props.asset.metadata;
    var result = [];

    if (!props.asset.id && (!metadata || Object.keys(metadata).length === 0)) {
      var entry = [];
      entry[0] = "description";
      entry[1] = "a file";
      result.push(entry);
      return result;
    }

    Object.keys(metadata).forEach(function (key) {
      var entry = [];
      entry[0] = key;
      entry[1] = metadata[key];
      result.push(entry);
    });
    return result;
  };

  var _useState = (0, _react.useState)(initialValues()),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  (0, _react.useEffect)(function () {
    onChange(); // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend"
  }, "Metadata"), /*#__PURE__*/_react["default"].createElement(_Repeater["default"], {
    id: "metadata-values",
    values: values,
    disabled: props.disabled,
    initialValue: [],
    setValues: setValues,
    addButtonText: "Add Metadata",
    component: function component(value, _onChange) {
      return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        spacing: 1
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        value: value[0],
        disabled: props.disabled,
        onChange: function onChange(e) {
          value[0] = e.target.value;

          _onChange(value);
        }
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        value: value[1],
        disabled: props.disabled,
        onChange: function onChange(e) {
          value[1] = e.target.value;

          _onChange(value);
        }
      })));
    }
  }));
};

exports.AssetMetadataEditor = AssetMetadataEditor;